<template>
    <div class="flex truncate items-center" v-bind="$attrs" v-on="$listeners">
        <slot v-if="!hideIcon" name="icon">
            <vx-basic-icon class="mr-3" icon="GlobeIcon" />
        </slot>
        <template v-if="hasLink && isValid">
            <span v-if="noLink">
                {{ website }}
            </span>
            <a v-else :href="websiteLink" :target="openNewPage ? '_blank' : ''">
                {{ website }}
            </a>
        </template>
        <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
            {{ website }}
            <span v-if="!isValid">*</span>
        </span>
        <slot name="append"></slot>
    </div>
</template>

<script>
const URL_REGEX = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
    'i'
) // fragment locator

export default {
    name: 'vx-web-link',
    props: {
        value: {
            type: String
        },
        openNewPage: {
            type: Boolean,
            default: false
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        noLink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasLink() {
            return !!this.value
        },
        websiteLink() {
            if (!this.value) {
                return null
            }
            if (this.value.startsWith('http')) {
                return this.website
            }
            return `//${this.website}`
        },
        website() {
            return this.value || 'No URL'
        },
        isValid() {
            return this.value && URL_REGEX.test(this.value)
        },
        favicon() {
            return `https://s2.googleusercontent.com/s2/favicons?domain_url=${this.value}`
        }
    }
}
</script>

<style></style>
